import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { DRAWER_MESSAGES } from '../../LoanEditorCustomFormDrawer.constants';

import {
  unsupportedItemsListItemStyles,
  unsupportedItemsListStyles,
  unsupportedItemsNoticeStyles,
} from './UnsupportedItemsNotice.styles';

const UnsupportedItemsNotice = ({
  entries,
  message = DRAWER_MESSAGES.UNSUPPORTED_FIELDS_NOTICE,
  dataTestId = 'loan-editor-custom-form-unsupported',
}) => {
  if (!entries.length) {
    return null;
  }

  return (
    <Box data-testid={dataTestId} sx={unsupportedItemsNoticeStyles}>
      <Typography color="textSecondary" variant="regular12">
        {message}
      </Typography>
      <Box component="ul" sx={unsupportedItemsListStyles}>
        {entries.map(({ key, label }) => (
          <Box component="li" key={key} sx={unsupportedItemsListItemStyles}>
            <Typography color="textSecondary" variant="regular12">
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

UnsupportedItemsNotice.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  message: PropTypes.string,
  dataTestId: PropTypes.string,
};

UnsupportedItemsNotice.displayName = 'UnsupportedItemsNotice';

export default memo(UnsupportedItemsNotice);
